<template>
  <div class="sound-speed-viz">
    
    <div class="viz-header" >
      <div class="brief" v-latex="knowledgePoint"></div>
      <div class="formula" v-latex>$<strong>公式：</strong>v = √(E/ρ) | 固体 > 液体 > 气体$</div>
    </div>

    <div class="main-layout vertical">
      <div class="canvas-box simulation">
        <svg width="100%" height="240" viewBox="0 0 400 240">
          <text x="20" y="30" fill="#fff" font-size="10">介质模型：{{ mediaName }}</text>
          
          <!-- Particles in media -->
          <g transform="translate(50, 60)">
             <g v-for="i in 10" :key="'col'+i">
                <circle v-for="j in 5" :key="'p'+i+j" :cx="calcCX(i)" :cy="j*20" r="4" :fill="particleColor" opacity="0.6" />
             </g>
          </g>

          <!-- Wave Front -->
          <line :x1="waveX" y1="50" :x2="waveX" y2="180" stroke="#ffd700" stroke-width="2" stroke-dasharray="4" />
        </svg>

        <div class="hud-top">
           <div class="stat">
              <label>估算声速: {{ speed }} m/s</label>
           </div>
        </div>
      </div>

      <div class="bottom-controls">
        <div class="control-card glass">
          <div class="row">
             <el-radio-group v-model="mediaType" size="mini">
                <el-radio label="gas">空气 (340m/s)</el-radio>
                <el-radio label="liquid">水 (1500m/s)</el-radio>
                <el-radio label="solid">钢铁 (5000m/s)</el-radio>
             </el-radio-group>
          </div>
        </div>

        <div class="discovery-note" v-latex>
           <p><strong>物理详解：</strong>声音是机械波，依靠介质分子的碰撞和振动传递。在**固体**中，原子间结合力（弹性模量）极强且排列紧密，振动传递极快；而**气体**分子间隙大、相互作用弱，传递速度最慢。这就是为什么铁轨传声远快于空气的原因。声速取决于介质的弹性性质和密度。</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SoundSpeedMediaViz',
  props: { knowledgePoint: { type: String, default: '' } },
  data() {
    return {
      mediaType: 'gas',
      time: 0,
      timer: null
    }
  },
  computed: {
    speed() {
       const map = { gas: 340, liquid: 1500, solid: 5000 };
       return map[this.mediaType];
    },
    mediaName() {
       const map = { gas: '气体 (稀疏/弱作用)', liquid: '液体 (较紧密)', solid: '固体 (紧密/强绑定的晶格)' };
       return map[this.mediaType];
    },
    particleColor() {
       const map = { gas: '#aaa', liquid: '#00d2ff', solid: '#ffd700' };
       return map[this.mediaType];
    },
    waveX() {
       let factor = this.speed / 100;
       return 50 + (this.time * factor) % 300;
    }
  },
  methods: {
    calcCX(i) {
       let base = i * 30;
       let amp = this.mediaType === 'gas' ? 10 : (this.mediaType === 'liquid' ? 5 : 2);
       // Disturbance when wave passes
       let dist = Math.max(0, 1 - Math.abs(50 + base - this.waveX)/40);
       return base + dist * amp * Math.sin(this.time * 5);
    },
    update() {
      this.time += 0.2;
      this.timer = requestAnimationFrame(this.update);
    }
  },
  mounted() { this.update(); },
  beforeDestroy() { cancelAnimationFrame(this.timer); }
}
</script>

<style scoped lang="scss">
.sound-speed-viz { flex: 1; display: flex; flex-direction: column; gap: 12px; height: 100%; overflow: hidden; }
.canvas-box { background: #020205; border-radius: 12px; position: relative; border: 1px solid rgba(255,255,255,0.05); }
.bottom-controls { flex: 0.6; display: flex; flex-direction: column; gap: 10px; }
.control-card { background: rgba(255,255,255,0.03); border-radius: 12px; padding: 15px; }
.discovery-note { background: rgba(0, 210, 255, 0.05); padding: 12px 18px; border-radius: 12px; p { margin: 0; font-size: 0.75rem; color: #aaa; line-height: 1.5; strong { color: #fff; } } }
</style>
